import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';

// Routes 

import { getDoctors, getGroups, getTeamMembers } from '../../../routes/hacker/users';
import { setDashboardSection } from '../../../redux/features/general/navigation';

// Components 

import ListHeader from '../../hacker/doctors/ListHeader';
import TeamMemberRow from './TeamMemberRow';
import LinearProgress from '@mui/material/LinearProgress';

// Icons 

// import Dropdown from './Dropdown';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TeamMembersHeader from './TeamMembersHeader';
import Section from '../../general/containers/Section';
import { setInitialRendering, setIsRefreshTeamMembersList, setSelectedTeamMember, setTeamMembers } from '../../../redux/features/hacker/users/teamMembersAccess';
import { setIsTeamMemberCreationPopupOpened } from '../../../redux/features/hacker/users/createTeamMember';

const TeamMembersList: React.FC = () => {

    const { t } = useTranslation();
    
    const dispatch = useAppDispatch();

    const colors = useAppSelector(state => state.theme.colors);  

    const isRefreshTeamMembersList = useAppSelector(state => state.teamMembersAccess.isRefreshTeamMembersList);  
    const selectedTeamMember = useAppSelector(state => state.teamMembersAccess.selectedTeamMember);  
    const teamMembers = useAppSelector(state => state.teamMembersAccess.teamMembers);  
    const initialRendering = useAppSelector(state => state.teamMembersAccess.initialRendering);  

    const [postionX, setPositionX] = useState(0); 
    const [positionY, setPositionY] = useState(0); 

    // -- 

    const getTeamMembersList = async () => { 

      const res = await getTeamMembers() as any; 

      if (res.data.status === 200) { 

        dispatch(setTeamMembers(res.data.teamMembers)); 

      };

    }; 

    // -- 

    const handleSelection = (e: any, teamMember: any) => { 

      if (selectedTeamMember) { 

        if (selectedTeamMember?._id == teamMember?._id) { 

          dispatch(setSelectedTeamMember(null)); 

          return; 
  
        }; 

      }; 

      setPositionX(e.pageX);
      setPositionY(e.pageY); 

      dispatch(setSelectedTeamMember(teamMember)); 

    }; 

    // -- 

    const handleCreation = () => { 

        dispatch(setIsTeamMemberCreationPopupOpened(true)); 

    }; 

    // -- 

    useEffect(() => { 

      if (initialRendering) { 

          getTeamMembersList(); 

          dispatch(setInitialRendering(false)); 

      }; 

    },[initialRendering]); 

    // -- 

    useEffect(() => { 

      if (isRefreshTeamMembersList) { 

        getTeamMembersList(); 

        dispatch(setIsRefreshTeamMembersList(false)); 

      }; 

    },[isRefreshTeamMembersList]); 

    // -- 
    
    return (

        <Section
          extraStyle={{ 
            backgroundColor: colors?.container,
            paddingLeft: '3vw', 
          }}
        >      
            
            <TeamMembersHeader />

            { (teamMembers?.length >= 1) && 
            <Box sx={{ 
                overflow: 'auto',
                width: '100%',
                marginTop: '2vh' }}>
        
                <List dense>
        
                {teamMembers?.map((teamMember, index) => (
        
                    <ListItem sx={{ color: colors?.text }} onClick={(e) => handleSelection(e, teamMember)} button key={index}>

                        <TeamMemberRow 
                            item={teamMember}
                        /> 
       
                    </ListItem>
                ))}
        
                </List>
        
            </Box>}

            {(teamMembers?.length === 0) &&         
          
            <Box sx={{ 
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-evenly', 
              height: '100%',
              width: '80%', 
          }}>

              <Box
                  sx={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
              }}>

                  <LinearProgress sx={{ width: 500, marginBottom: 10 }} /> 

                  <Box>Retrieving Team Members...</Box>

              </Box>

          </Box>}

          {/* { selectedTeamMember && <Dropdown positionX={postionX} positionY={positionY - 30} />} */}

          <AddCircleIcon 
            onClick={handleCreation}
            sx={{ 
              width: 70,
              height: 70, 
              color: 'rgb(45, 207, 196)', 
              position: 'absolute', 
              bottom: 30, 
              right: 30, 
              cursor: 'pointer',
              '&:hover' : { color: 'rgb(65, 227, 216)'}
            }}
          />

        </Section>
    
      );

};

export default TeamMembersList;